"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COLLECTIONS = void 0;
const COLLECTIONS = {
  ITEMS: 'fleet',
  ITEM_REVIEWS: 'fleet/:id/reviews',
  USERS: 'users',
  USER_REVIEWS: 'users/:id/reviews',
  NOTIFICATIONS: 'users/:id/notifications',
  MESSAGES: 'messages',
  RENTALS: 'rentals'
};
exports.COLLECTIONS = COLLECTIONS;
//# sourceMappingURL=collections.js.map